const ANIMATIONS_KEYFRAME = {
  kick: `
    from,
    20%,
    53%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: translate3d(0, 0, 0);
    }

    40%,
    43% {
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      transform: translate3d(0, -30px, 0) scaleY(1.1);
    }

    70% {
      animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      transform: translate3d(0, -15px, 0) scaleY(1.05);
    }

    80% {
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transform: translate3d(0, 0, 0) scaleY(0.95);
    }

    90% {
      transform: translate3d(0, -4px, 0) scaleY(1.02);
    }
`,
  flash: `
    from,
    50%,
    to {
      opacity: 1;
    }

    25%,
    75% {
      opacity: 0;
    }
`,
  glow: `
    from {
      transform: scale3d(1, 1, 1);
    }

    50% {
      transform: scale3d(1.05, 1.05, 1.05);
    }

    to {
      transform: scale3d(1, 1, 1);
    }
`,
  rubberBand: `
    from {
      transform: scale3d(1, 1, 1);
    }

    30% {
      transform: scale3d(1.25, 0.75, 1);
    }

    40% {
      transform: scale3d(0.75, 1.25, 1);
    }

    50% {
      transform: scale3d(1.15, 0.85, 1);
    }

    65% {
      transform: scale3d(0.95, 1.05, 1);
    }

    75% {
      transform: scale3d(1.05, 0.95, 1);
    }

    to {
      transform: scale3d(1, 1, 1);
    }
`,
  shakeX: `
    from,
    to {
      transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
      transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
      transform: translate3d(10px, 0, 0);
    }
`,
  shakeY: `
    from,
    to {
      transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
      transform: translate3d(0, -10px, 0);
    }

    20%,
    40%,
    60%,
    80% {
      transform: translate3d(0, 10px, 0);
    }
`,
  headShake: `
    0% {
      transform: translateX(0);
    }

    6.5% {
      transform: translateX(-6px) rotateY(-9deg);
    }

    18.5% {
      transform: translateX(5px) rotateY(7deg);
    }

    31.5% {
      transform: translateX(-3px) rotateY(-5deg);
    }

    43.5% {
      transform: translateX(2px) rotateY(3deg);
    }

    50% {
      transform: translateX(0);
    }
`,
  heartBeat: `
    0% {
      transform: scale(1);
    }

    14% {
      transform: scale(1.3);
    }

    28% {
      transform: scale(1);
    }

    42% {
      transform: scale(1.3);
    }

    70% {
      transform: scale(1);
    }
`,
  jello: `
    from,
    11.1%,
    to {
      transform: translate3d(0, 0, 0);
    }

    22.2% {
      transform: skewX(-12.5deg) skewY(-12.5deg);
    }

    33.3% {
      transform: skewX(6.25deg) skewY(6.25deg);
    }

    44.4% {
      transform: skewX(-3.125deg) skewY(-3.125deg);
    }

    55.5% {
      transform: skewX(1.5625deg) skewY(1.5625deg);
    }

    66.6% {
      transform: skewX(-0.78125deg) skewY(-0.78125deg);
    }

    77.7% {
      transform: skewX(0.390625deg) skewY(0.390625deg);
    }

    88.8% {
      transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
    }
`,
  shake: `
    from,
    to {
      transform: translate3d(0, 0, 0);
    }

    10%,
    30%,
    50%,
    70%,
    90% {
      transform: translate3d(-10px, 0, 0);
    }

    20%,
    40%,
    60%,
    80% {
      transform: translate3d(10px, 0, 0);
    }
`,
  swing: `
    20% {
      transform: rotate3d(0, 0, 1, 15deg);
    }

    40% {
      transform: rotate3d(0, 0, 1, -10deg);
    }

    60% {
      transform: rotate3d(0, 0, 1, 5deg);
    }

    80% {
      transform: rotate3d(0, 0, 1, -5deg);
    }

    to {
      transform: rotate3d(0, 0, 1, 0deg);
    }
`,
  tada: `
    from {
      transform: scale3d(1, 1, 1);
    }

    10%,
    20% {
      transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    }

    30%,
    50%,
    70%,
    90% {
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    }

    40%,
    60%,
    80% {
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    }

    to {
      transform: scale3d(1, 1, 1);
    }
  `,
  wobble: `
    from {
      transform: translate3d(0, 0, 0);
    }

    15% {
      transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
    }

    30% {
      transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
    }

    45% {
      transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
    }

    60% {
      transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
    }

    75% {
      transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  `,
  backInDown: `
    0% {
      transform: translateY(-1200px) scale(0.7);
      opacity: 0.7;
    }

    80% {
      transform: translateY(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }`,
  backInLeft: `
    0% {
      transform: translateX(-2000px) scale(0.7);
      opacity: 0.7;
    }

    80% {
      transform: translateX(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }`,
  backInRight: `
    0% {
      transform: translateX(2000px) scale(0.7);
      opacity: 0.7;
    }

    80% {
      transform: translateX(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }`,
  backInUp: `
    0% {
      transform: translateY(1200px) scale(0.7);
      opacity: 0.7;
    }

    80% {
      transform: translateY(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }`,
  backOutDown: `
    0% {
      transform: scale(1);
      opacity: 1;
    }

    20% {
      transform: translateY(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: translateY(700px) scale(0.7);
      opacity: 0.7;
    }`,
  backOutLeft: `
    0% {
      transform: scale(1);
      opacity: 1;
    }

    20% {
      transform: translateX(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: translateX(-2000px) scale(0.7);
      opacity: 0.7;
    }`,
  backOutRight: `
    0% {
      transform: scale(1);
      opacity: 1;
    }

    20% {
      transform: translateX(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: translateX(2000px) scale(0.7);
      opacity: 0.7;
    }`,
  backOutUp: `
    0% {
      transform: scale(1);
      opacity: 1;
    }

    20% {
      transform: translateY(0px) scale(0.7);
      opacity: 0.7;
    }

    100% {
      transform: translateY(-700px) scale(0.7);
      opacity: 0.7;
    }`,
  bounceIn: `
    from,
    20%,
    40%,
    60%,
    80%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    20% {
      transform: scale3d(1.1, 1.1, 1.1);
    }

    40% {
      transform: scale3d(0.9, 0.9, 0.9);
    }

    60% {
      opacity: 1;
      transform: scale3d(1.03, 1.03, 1.03);
    }

    80% {
      transform: scale3d(0.97, 0.97, 0.97);
    }

    to {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }`,
  bounceInDown: `
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0) scaleY(3);
    }

    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0) scaleY(0.9);
    }

    75% {
      transform: translate3d(0, -10px, 0) scaleY(0.95);
    }

    90% {
      transform: translate3d(0, 5px, 0) scaleY(0.985);
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  bounceInLeft: `
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      transform: translate3d(-3000px, 0, 0) scaleX(3);
    }

    60% {
      opacity: 1;
      transform: translate3d(25px, 0, 0) scaleX(1);
    }

    75% {
      transform: translate3d(-10px, 0, 0) scaleX(0.98);
    }

    90% {
      transform: translate3d(5px, 0, 0) scaleX(0.995);
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  bounceInRight: `
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0) scaleX(3);
    }

    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0) scaleX(1);
    }

    75% {
      transform: translate3d(10px, 0, 0) scaleX(0.98);
    }

    90% {
      transform: translate3d(-5px, 0, 0) scaleX(0.995);
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  bounceInUp: `
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0) scaleY(5);
    }

    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0) scaleY(0.9);
    }

    75% {
      transform: translate3d(0, 10px, 0) scaleY(0.95);
    }

    90% {
      transform: translate3d(0, -5px, 0) scaleY(0.985);
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  bounceOut: `
    20% {
      transform: scale3d(0.9, 0.9, 0.9);
    }

    50%,
    55% {
      opacity: 1;
      transform: scale3d(1.1, 1.1, 1.1);
    }

    to {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }`,
  bounceOutDown: `
    20% {
      transform: translate3d(0, 10px, 0) scaleY(0.985);
    }

    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0) scaleY(0.9);
    }

    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0) scaleY(3);
    }`,
  bounceOutLeft: `
    20% {
      opacity: 1;
      transform: translate3d(20px, 0, 0) scaleX(0.9);
    }

    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0) scaleX(2);
    }`,
  bounceOutRight: `
    20% {
      opacity: 1;
      transform: translate3d(-20px, 0, 0) scaleX(0.9);
    }

    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0) scaleX(2);
    }`,
  bounceOutUp: `
    20% {
      transform: translate3d(0, -10px, 0) scaleY(0.985);
    }

    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0) scaleY(0.9);
    }

    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0) scaleY(3);
    }`,
  fadeIn: `
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }`,
  fadeInDown: `
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInDownBig: `
    from {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInLeft: `
    from {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInLeftBig: `
    from {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInRight: `
    from {
      opacity: 0;
      transform: translate3d(100%, 0, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInRightBig: `
    from {
      opacity: 0;
      transform: translate3d(2000px, 0, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInUp: `
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInUpBig: `
    from {
      opacity: 0;
      transform: translate3d(0, 2000px, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInTopLeft: `
    from {
      opacity: 0;
      transform: translate3d(-100%, -100%, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInTopRight: `
    from {
      opacity: 0;
      transform: translate3d(100%, -100%, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInBottomLeft: `
    from {
      opacity: 0;
      transform: translate3d(-100%, 100%, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeInBottomRight: `
    from {
      opacity: 0;
      transform: translate3d(100%, 100%, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  fadeOut: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }`,
  fadeOutDown: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }`,
  fadeOutDownBig: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0);
    }`,
  fadeOutLeft: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }`,
  fadeOutLeftBig: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0);
    }`,
  fadeOutRight: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(100%, 0, 0);
    }`,
  fadeOutRightBig: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0);
    }`,
  fadeOutUp: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }`,
  fadeOutUpBig: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }`,
  fadeOutTopLeft: `
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(-100%, -100%, 0);
    }`,
  fadeOutTopRight: `
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(100%, -100%, 0);
    }`,
  fadeOutBottomLeft: `
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(-100%, 100%, 0);
    }`,
  fadeOutBottomRight: `
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(100%, 100%, 0);
    }`,
  flip: `
    from {
      transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);
      animation-timing-function: ease-out;
    }

    40% {
      transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
        rotate3d(0, 1, 0, -190deg);
      animation-timing-function: ease-out;
    }

    50% {
      transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
        rotate3d(0, 1, 0, -170deg);
      animation-timing-function: ease-in;
    }

    80% {
      transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)
        rotate3d(0, 1, 0, 0deg);
      animation-timing-function: ease-in;
    }

    to {
      transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
      animation-timing-function: ease-in;
    }`,
  flipInX: `
    from {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0;
    }

    40% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in;
    }

    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity: 1;
    }

    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }

    to {
      transform: perspective(400px);
    }`,
  flipInY: `
    from {
      transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0;
    }

    40% {
      transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
      animation-timing-function: ease-in;
    }

    60% {
      transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
      opacity: 1;
    }

    80% {
      transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
    }

    to {
      transform: perspective(400px);
    }`,
  flipOutX: `
    from {
      transform: perspective(400px);
    }

    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity: 1;
    }

    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity: 0;
    }`,
  flipOutY: `
    from {
      transform: perspective(400px);
    }

    30% {
      transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
      opacity: 1;
    }

    to {
      transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
      opacity: 0;
    }`,
  lightSpeedInLeft: `
    from {
      transform: translate3d(-100%, 0, 0) skewX(30deg);
      opacity: 0;
    }

    60% {
      transform: skewX(-20deg);
      opacity: 1;
    }

    80% {
      transform: skewX(5deg);
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  lightSpeedInRight: `
    from {
      transform: translate3d(100%, 0, 0) skewX(-30deg);
      opacity: 0;
    }

    60% {
      transform: skewX(20deg);
      opacity: 1;
    }

    80% {
      transform: skewX(-5deg);
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  lightSpeedOutLeft: `
    from {
      opacity: 1;
    }

    to {
      transform: translate3d(-100%, 0, 0) skewX(-30deg);
      opacity: 0;
    }`,
  lightSpeedOutRight: `
    from {
      opacity: 1;
    }

    to {
      transform: translate3d(100%, 0, 0) skewX(30deg);
      opacity: 0;
    }`,
  rotateIn: `
    from {
      transform: rotate3d(0, 0, 1, -200deg);
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }`,
  rotateInDownLeft: `
    from {
      transform: rotate3d(0, 0, 1, -45deg);
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }`,
  rotateInDownRight: `
    from {
      transform: rotate3d(0, 0, 1, 45deg);
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }`,
  rotateInUpLeft: `
    from {
      transform: rotate3d(0, 0, 1, 45deg);
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }`,
  rotateInUpRight: `
    from {
      transform: rotate3d(0, 0, 1, -90deg);
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }`,
  rotateOut: `
    from {
      opacity: 1;
    }

    to {
      transform: rotate3d(0, 0, 1, 200deg);
      opacity: 0;
    }`,
  rotateOutDownLeft: `
    from {
      opacity: 1;
    }

    to {
      transform: rotate3d(0, 0, 1, 45deg);
      opacity: 0;
    }`,
  rotateOutDownRight: `
    from {
      opacity: 1;
    }

    to {
      transform: rotate3d(0, 0, 1, -45deg);
      opacity: 0;
    }`,
  rotateOutUpLeft: `
    from {
      opacity: 1;
    }

    to {
      transform: rotate3d(0, 0, 1, -45deg);
      opacity: 0;
    }`,
  rotateOutUpRight: `
    from {
      opacity: 1;
    }

    to {
      transform: rotate3d(0, 0, 1, 90deg);
      opacity: 0;
    }`,
  slideInDown: `
    from {
      transform: translate3d(0, -100%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  slideInLeft: `
    from {
      transform: translate3d(-100%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  slideInRight: `
    from {
      transform: translate3d(100%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  slideInUp: `
    from {
      transform: translate3d(0, 100%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }`,
  slideOutDown: `
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform: translate3d(0, 100%, 0);
    }`,
  slideOutLeft: `
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform: translate3d(-100%, 0, 0);
    }`,
  slideOutRight: `
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform: translate3d(100%, 0, 0);
    }`,
  slideOutUp: `
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform: translate3d(0, -100%, 0);
    }`,
  hinge: `
    0% {
      animation-timing-function: ease-in-out;
    }

    20%,
    60% {
      transform: rotate3d(0, 0, 1, 80deg);
      animation-timing-function: ease-in-out;
    }

    40%,
    80% {
      transform: rotate3d(0, 0, 1, 60deg);
      animation-timing-function: ease-in-out;
      opacity: 1;
    }

    to {
      transform: translate3d(0, 700px, 0);
      opacity: 0;
    }`,
  jackInTheBox: `
    from {
      opacity: 0;
      transform: scale(0.1) rotate(30deg);
      transform-origin: center bottom;
    }

    50% {
      transform: rotate(-10deg);
    }

    70% {
      transform: rotate(3deg);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }`,
  rollIn: `
    from {
      opacity: 0;
      transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }`,
  rollOut: `
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
    }`,
  zoomIn: `
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
      opacity: 1;
    }`,
  zoomInDown: `
    from {
      opacity: 0;
      transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    60% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
      animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }`,
  zoomInLeft: `
    from {
      opacity: 0;
      transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    60% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
      animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }`,
  zoomInRight: `
    from {
      opacity: 0;
      transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    60% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
      animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }`,
  zoomInUp: `
    from {
      opacity: 0;
      transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    60% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
      animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }`,
  zoomOut: `
    from {
      opacity: 1;
    }

    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    to {
      opacity: 0;
    }`,
  zoomOutDown: `
    40% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    to {
      opacity: 0;
      transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
      animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }`,
  zoomOutLeft: `
    40% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
    }

    to {
      opacity: 0;
      transform: scale(0.1) translate3d(-2000px, 0, 0);
    }`,
  zoomOutRight: `
    40% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
    }

    to {
      opacity: 0;
      transform: scale(0.1) translate3d(2000px, 0, 0);
    }`,
  zoomOutUp: `
    40% {
      opacity: 1;
      transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    to {
      opacity: 0;
      transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
      animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    }`,
  bounce: `
    0%, 100% {
      transform: translateY(-25%);
      animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }
    50% {
      transform: none;
      animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }`,
  spin: `
    to {
      transform: rotate(360deg);
    }`,
  ping: `
    75%, 100% {
      transform: scale(2);
      opacity: 0;
    }`,
  pulse: `
    50% {
      opacity: 0.5;
    }`,
}

const ANIMATION_LIST = [
  { name: 'bounce', keyframe: ANIMATIONS_KEYFRAME.bounce, category: 'Default' },
  { name: 'spin', keyframe: ANIMATIONS_KEYFRAME.spin, category: 'Default' },
  { name: 'ping', keyframe: ANIMATIONS_KEYFRAME.ping, category: 'Default' },
  { name: 'pulse', keyframe: ANIMATIONS_KEYFRAME.pulse, category: 'Default' },

  { name: 'kick', keyframe: ANIMATIONS_KEYFRAME.kick, category: 'Attention Seekers' },
  { name: 'flash', keyframe: ANIMATIONS_KEYFRAME.flash, category: 'Attention Seekers' },
  { name: 'headShake', keyframe: ANIMATIONS_KEYFRAME.headShake, category: 'Attention Seekers' },
  { name: 'heartBeat', keyframe: ANIMATIONS_KEYFRAME.heartBeat, category: 'Attention Seekers' },
  { name: 'jello', keyframe: ANIMATIONS_KEYFRAME.jello, category: 'Attention Seekers' },
  { name: 'glow', keyframe: ANIMATIONS_KEYFRAME.glow, category: 'Attention Seekers' },
  { name: 'rubberBand', keyframe: ANIMATIONS_KEYFRAME.rubberBand, category: 'Attention Seekers' },
  { name: 'shake', keyframe: ANIMATIONS_KEYFRAME.shake, category: 'Attention Seekers' },
  { name: 'shakeX', keyframe: ANIMATIONS_KEYFRAME.shakeX, category: 'Attention Seekers' },
  { name: 'shakeY', keyframe: ANIMATIONS_KEYFRAME.shakeY, category: 'Attention Seekers' },
  { name: 'swing', keyframe: ANIMATIONS_KEYFRAME.swing, category: 'Attention Seekers' },
  { name: 'tada', keyframe: ANIMATIONS_KEYFRAME.tada, category: 'Attention Seekers' },
  { name: 'wobble', keyframe: ANIMATIONS_KEYFRAME.wobble, category: 'Attention Seekers' },

  { name: 'backInDown', keyframe: ANIMATIONS_KEYFRAME.backInDown, category: 'Back Entrances' },
  { name: 'backInLeft', keyframe: ANIMATIONS_KEYFRAME.backInLeft, category: 'Back Entrances' },
  { name: 'backInRight', keyframe: ANIMATIONS_KEYFRAME.backInRight, category: 'Back Entrances' },
  { name: 'backInUp', keyframe: ANIMATIONS_KEYFRAME.backInUp, category: 'Back Entrances' },

  { name: 'backOutDown', keyframe: ANIMATIONS_KEYFRAME.backOutDown, category: 'Back Exits' },
  { name: 'backOutLeft', keyframe: ANIMATIONS_KEYFRAME.backOutLeft, category: 'Back Exits' },
  { name: 'backOutRight', keyframe: ANIMATIONS_KEYFRAME.backOutRight, category: 'Back Exits' },
  { name: 'backOutUp', keyframe: ANIMATIONS_KEYFRAME.backOutUp, category: 'Back Exits' },

  { name: 'bounceIn', keyframe: ANIMATIONS_KEYFRAME.bounceIn, category: 'Bounce Entrances' },
  { name: 'bounceInDown', keyframe: ANIMATIONS_KEYFRAME.bounceInDown, category: 'Bounce Entrances' },
  { name: 'bounceInLeft', keyframe: ANIMATIONS_KEYFRAME.bounceInLeft, category: 'Bounce Entrances' },
  { name: 'bounceInRight', keyframe: ANIMATIONS_KEYFRAME.bounceInRight, category: 'Bounce Entrances' },
  { name: 'bounceInUp', keyframe: ANIMATIONS_KEYFRAME.bounceInUp, category: 'Bounce Entrances' },

  { name: 'bounceOut', keyframe: ANIMATIONS_KEYFRAME.bounceOut, category: 'Bounce Exits' },
  { name: 'bounceOutDown', keyframe: ANIMATIONS_KEYFRAME.bounceOutDown, category: 'Bounce Exits' },
  { name: 'bounceOutLeft', keyframe: ANIMATIONS_KEYFRAME.bounceOutLeft, category: 'Bounce Exits' },
  { name: 'bounceOutRight', keyframe: ANIMATIONS_KEYFRAME.bounceOutRight, category: 'Bounce Exits' },
  { name: 'bounceOutUp', keyframe: ANIMATIONS_KEYFRAME.bounceOutUp, category: 'Bounce Exits' },

  { name: 'fadeIn', keyframe: ANIMATIONS_KEYFRAME.fadeIn, category: 'Fade Entrances' },
  { name: 'fadeInDown', keyframe: ANIMATIONS_KEYFRAME.fadeInDown, category: 'Fade Entrances' },
  { name: 'fadeInDownBig', keyframe: ANIMATIONS_KEYFRAME.fadeInDownBig, category: 'Fade Entrances' },
  { name: 'fadeInLeft', keyframe: ANIMATIONS_KEYFRAME.fadeInLeft, category: 'Fade Entrances' },
  { name: 'fadeInLeftBig', keyframe: ANIMATIONS_KEYFRAME.fadeInLeftBig, category: 'Fade Entrances' },
  { name: 'fadeInRight', keyframe: ANIMATIONS_KEYFRAME.fadeInRight, category: 'Fade Entrances' },
  { name: 'fadeInRightBig', keyframe: ANIMATIONS_KEYFRAME.fadeInRightBig, category: 'Fade Entrances' },
  { name: 'fadeInUp', keyframe: ANIMATIONS_KEYFRAME.fadeInUp, category: 'Fade Entrances' },
  { name: 'fadeInUpBig', keyframe: ANIMATIONS_KEYFRAME.fadeInUpBig, category: 'Fade Entrances' },
  { name: 'fadeInTopLeft', keyframe: ANIMATIONS_KEYFRAME.fadeInTopLeft, category: 'Fade Entrances' },
  { name: 'fadeInTopRight', keyframe: ANIMATIONS_KEYFRAME.fadeInTopRight, category: 'Fade Entrances' },
  { name: 'fadeInBottomLeft', keyframe: ANIMATIONS_KEYFRAME.fadeInBottomLeft, category: 'Fade Entrances' },
  { name: 'fadeInBottomRight', keyframe: ANIMATIONS_KEYFRAME.fadeInBottomRight, category: 'Fade Entrances' },

  { name: 'fadeOut', keyframe: ANIMATIONS_KEYFRAME.fadeOut, category: 'Fade Exits' },
  { name: 'fadeOutDown', keyframe: ANIMATIONS_KEYFRAME.fadeOutDown, category: 'Fade Exits' },
  { name: 'fadeOutDownBig', keyframe: ANIMATIONS_KEYFRAME.fadeOutDownBig, category: 'Fade Exits' },
  { name: 'fadeOutLeft', keyframe: ANIMATIONS_KEYFRAME.fadeOutLeft, category: 'Fade Exits' },
  { name: 'fadeOutLeftBig', keyframe: ANIMATIONS_KEYFRAME.fadeOutLeftBig, category: 'Fade Exits' },
  { name: 'fadeOutRight', keyframe: ANIMATIONS_KEYFRAME.fadeOutRight, category: 'Fade Exits' },
  { name: 'fadeOutRightBig', keyframe: ANIMATIONS_KEYFRAME.fadeOutRightBig, category: 'Fade Exits' },
  { name: 'fadeOutUp', keyframe: ANIMATIONS_KEYFRAME.fadeOutUp, category: 'Fade Exits' },
  { name: 'fadeOutUpBig', keyframe: ANIMATIONS_KEYFRAME.fadeOutUpBig, category: 'Fade Exits' },
  { name: 'fadeOutTopLeft', keyframe: ANIMATIONS_KEYFRAME.fadeOutTopLeft, category: 'Fade Exits' },
  { name: 'fadeOutTopRight', keyframe: ANIMATIONS_KEYFRAME.fadeOutTopRight, category: 'Fade Exits' },
  { name: 'fadeOutBottomLeft', keyframe: ANIMATIONS_KEYFRAME.fadeOutBottomLeft, category: 'Fade Exits' },
  { name: 'fadeOutBottomRight', keyframe: ANIMATIONS_KEYFRAME.fadeOutBottomRight, category: 'Fade Exits' },

  { name: 'flip', keyframe: ANIMATIONS_KEYFRAME.flip, category: 'Flip' },
  { name: 'flipInX', keyframe: ANIMATIONS_KEYFRAME.flipInX, category: 'Flip' },
  { name: 'flipInY', keyframe: ANIMATIONS_KEYFRAME.flipInY, category: 'Flip' },
  { name: 'flipOutX', keyframe: ANIMATIONS_KEYFRAME.flipOutX, category: 'Flip' },
  { name: 'flipOutY', keyframe: ANIMATIONS_KEYFRAME.flipOutY, category: 'Flip' },

  { name: 'lightSpeedInLeft', keyframe: ANIMATIONS_KEYFRAME.lightSpeedInLeft, category: 'LightSpeed' },
  { name: 'lightSpeedInRight', keyframe: ANIMATIONS_KEYFRAME.lightSpeedInRight, category: 'LightSpeed' },
  { name: 'lightSpeedOutLeft', keyframe: ANIMATIONS_KEYFRAME.lightSpeedOutLeft, category: 'LightSpeed' },
  { name: 'lightSpeedOutRight', keyframe: ANIMATIONS_KEYFRAME.lightSpeedOutRight, category: 'LightSpeed' },

  { name: 'rotateIn', keyframe: ANIMATIONS_KEYFRAME.rotateIn, category: 'Rotating Entrances' },
  { name: 'rotateInDownLeft', keyframe: ANIMATIONS_KEYFRAME.rotateInDownLeft, category: 'Rotating Entrances' },
  { name: 'rotateInDownRight', keyframe: ANIMATIONS_KEYFRAME.rotateInDownRight, category: 'Rotating Entrances' },
  { name: 'rotateInUpLeft', keyframe: ANIMATIONS_KEYFRAME.rotateInUpLeft, category: 'Rotating Entrances' },
  { name: 'rotateInUpRight', keyframe: ANIMATIONS_KEYFRAME.rotateInUpRight, category: 'Rotating Entrances' },

  { name: 'rotateOut', keyframe: ANIMATIONS_KEYFRAME.rotateOut, category: 'Rotating Exits' },
  { name: 'rotateOutDownLeft', keyframe: ANIMATIONS_KEYFRAME.rotateOutDownLeft, category: 'Rotating Exits' },
  { name: 'rotateOutDownRight', keyframe: ANIMATIONS_KEYFRAME.rotateOutDownRight, category: 'Rotating Exits' },
  { name: 'rotateOutUpLeft', keyframe: ANIMATIONS_KEYFRAME.rotateOutUpLeft, category: 'Rotating Exits' },
  { name: 'rotateOutUpRight', keyframe: ANIMATIONS_KEYFRAME.rotateOutUpRight, category: 'Rotating Exits' },

  { name: 'slideInDown', keyframe: ANIMATIONS_KEYFRAME.slideInDown, category: 'Sliding Entrances' },
  { name: 'slideInLeft', keyframe: ANIMATIONS_KEYFRAME.slideInLeft, category: 'Sliding Entrances' },
  { name: 'slideInRight', keyframe: ANIMATIONS_KEYFRAME.slideInRight, category: 'Sliding Entrances' },
  { name: 'slideInUp', keyframe: ANIMATIONS_KEYFRAME.slideInUp, category: 'Sliding Entrances' },

  { name: 'slideOutDown', keyframe: ANIMATIONS_KEYFRAME.slideOutDown, category: 'Sliding Exits' },
  { name: 'slideOutLeft', keyframe: ANIMATIONS_KEYFRAME.slideOutLeft, category: 'Sliding Exits' },
  { name: 'slideOutRight', keyframe: ANIMATIONS_KEYFRAME.slideOutRight, category: 'Sliding Exits' },
  { name: 'slideOutUp', keyframe: ANIMATIONS_KEYFRAME.slideOutUp, category: 'Sliding Exits' },

  { name: 'jackInTheBox', keyframe: ANIMATIONS_KEYFRAME.jackInTheBox, category: 'Specials' },
  { name: 'hinge', keyframe: ANIMATIONS_KEYFRAME.hinge, category: 'Specials' },
  { name: 'rollIn', keyframe: ANIMATIONS_KEYFRAME.rollIn, category: 'Specials' },
  { name: 'rollOut', keyframe: ANIMATIONS_KEYFRAME.rollOut, category: 'Specials' },

  { name: 'zoomIn', keyframe: ANIMATIONS_KEYFRAME.zoomIn, category: 'Zooming Entrances' },
  { name: 'zoomInDown', keyframe: ANIMATIONS_KEYFRAME.zoomInDown, category: 'Zooming Entrances' },
  { name: 'zoomInLeft', keyframe: ANIMATIONS_KEYFRAME.zoomInLeft, category: 'Zooming Entrances' },
  { name: 'zoomInRight', keyframe: ANIMATIONS_KEYFRAME.zoomInRight, category: 'Zooming Entrances' },
  { name: 'zoomInUp', keyframe: ANIMATIONS_KEYFRAME.zoomInUp, category: 'Zooming Entrances' },

  { name: 'zoomOut', keyframe: ANIMATIONS_KEYFRAME.zoomOut, category: 'Zooming Exits' },
  { name: 'zoomOutDown', keyframe: ANIMATIONS_KEYFRAME.zoomOutDown, category: 'Zooming Exits' },
  { name: 'zoomOutLeft', keyframe: ANIMATIONS_KEYFRAME.zoomOutLeft, category: 'Zooming Exits' },
  { name: 'zoomOutRight', keyframe: ANIMATIONS_KEYFRAME.zoomOutRight, category: 'Zooming Exits' },
  { name: 'zoomOutUp', keyframe: ANIMATIONS_KEYFRAME.zoomOutUp, category: 'Zooming Exits' },
]

const ANIMATION_KEYS = {
  ...ANIMATION_LIST.reduce((acc, item) => {
    acc[item.name] = item.keyframe
    return acc
  }, {}),
}

const ANIMATION_CATEGORIES = [
  { category: 'Default', items: ANIMATION_LIST.filter(item => item.category.includes('Default')) },
  { category: 'Attention Seekers', items: ANIMATION_LIST.filter(item => item.category.includes('Attention Seekers')) },
  { category: 'Bounce', items: ANIMATION_LIST.filter(item => item.category.includes('Bounce')) },
  { category: 'Back Entrances', items: ANIMATION_LIST.filter(item => item.category.includes('Back Entrances')) },
  { category: 'Back Exits', items: ANIMATION_LIST.filter(item => item.category.includes('Back Exits')) },
  { category: 'Bounce Entrances', items: ANIMATION_LIST.filter(item => item.category.includes('Bounce Entrances')) },
  { category: 'Bounce Exits', items: ANIMATION_LIST.filter(item => item.category.includes('Bounce Exits')) },
  { category: 'Fade Entrances', items: ANIMATION_LIST.filter(item => item.category.includes('Fade Entrances')) },
  { category: 'Fade Exits', items: ANIMATION_LIST.filter(item => item.category.includes('Fade Exits')) },
  { category: 'Flip', items: ANIMATION_LIST.filter(item => item.category.includes('Flip')) },
  { category: 'LightSpeed', items: ANIMATION_LIST.filter(item => item.category.includes('LightSpeed')) },
  { category: 'Rotating Entrances', items: ANIMATION_LIST.filter(item => item.category.includes('Rotating Entrances')) },
  { category: 'Rotating Exits', items: ANIMATION_LIST.filter(item => item.category.includes('Rotating Exits')) },
  { category: 'Sliding Entrances', items: ANIMATION_LIST.filter(item => item.category.includes('Sliding Entrances')) },
  { category: 'Sliding Exits', items: ANIMATION_LIST.filter(item => item.category.includes('Sliding Exits')) },
  { category: 'Specials', items: ANIMATION_LIST.filter(item => item.category.includes('Specials')) },
  { category: 'Zooming Entrances', items: ANIMATION_LIST.filter(item => item.category.includes('Zooming Entrances')) },
  { category: 'Zooming Exits', items: ANIMATION_LIST.filter(item => item.category.includes('Zooming Exits')) },
]

export { ANIMATION_LIST, ANIMATIONS_KEYFRAME, ANIMATION_CATEGORIES, ANIMATION_KEYS }
